export default __webpack_public_path__ + "static/media/Afacad-Medium.2bcb925b.ttf";